import standardStyles from "exports.module.scss";
import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";

import { useWindowSize } from "@seneca/senekit";

import { getDimensionFromCSSVar } from "seneca-common/utils/functions";

import { closeSidebar, openSidebar } from "features/classroom/state";

export const MIN_SIDEBAR_OPEN_SCREEN_WIDTH = getDimensionFromCSSVar(
  standardStyles.minsidebaropenscreenwidth
);

export default function useCloseSidebarOnWindowResizeIfNecessary() {
  const dispatch = useDispatch();

  const openSidebarOnWindowResize = useCallback(
    (width: number) => {
      if (width >= MIN_SIDEBAR_OPEN_SCREEN_WIDTH) {
        dispatch(openSidebar());
      } else {
        dispatch(closeSidebar());
      }
    },
    [dispatch]
  );

  const { width } = useWindowSize();

  useEffect(() => {
    openSidebarOnWindowResize(width);
  }, [width, openSidebarOnWindowResize]);
}
